import styled from 'styled-components'

export const DashboardCSSVariables = styled.div`
    --dashboard-white-color: ${(props) => props.theme.colors.monochrome.white};
    --dashboard-basic-background-color: ${(props) =>
        props.theme.colors.monochrome.white};
    --dashboard-main-color: ${(props) =>
        props.theme.colors.brand.rideOctaneBlue};
    --dashboard-main-color-light: ${(props) =>
        props.theme.colors.brand.rideOctaneBlue}10;
    --dashboard-secondary-color: ${(props) =>
        props.theme.colors.monochrome.asphalt};
    --dashboard-black-color: ${(props) =>
        props.theme.colors.monochrome.jetlineBlack};
    --dashboard-default-border: solid 1px
        ${(props) => props.theme.colors.monochrome.smoke};
    --dashboard-default-border-thin: solid 0.5px
        ${(props) => props.theme.colors.monochrome.concrete};
    --dashboard-border-radius: 20px;
    --dashboard-default-gap: 20px;
    --dashboard-pro-color: #edf67d;
    --dashboard-allstar-color: #33e1ed;
    --dashboard-mvp-color: #ffbe5e;

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translate(0, -5px);
        }
        to {
            opacity: 1;
            transform: translate(0, 0);
        }
    }
`

export const DashboardContainer = styled.div`
    width: 1200px;
    margin: 0 auto 5em;
    h2 {
        margin-top: 80px;
        margin-bottom: 0;
        color: var(--dashboard-secondary-color);
        font-size: 38px;
        font-weight: bold;
        border-bottom: var(--dashboard-default-border-thin);
        padding: var(--dashboard-default-gap) 0;
        animation: fadeIn 0.4s ease-in-out;
    }
`

export const QuickActions = styled.div`
    border-bottom: var(--dashboard-default-border-thin);
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    animation: fadeIn 0.3s ease-in-out;
    h3 {
        margin-top: 0;
        font-weight: bold;
        font-size: 20px;
        margin-right: 40px;
        padding-top: 15px;
    }
    button {
        border: none;
        border-radius: 2px;
        font-size: 15px;
        color: var(--dashboard-white-color);
        background-color: var(--dashboard-main-color);
        padding: 8px 25px;
        margin: 15px;
        height: 40px;
        animation: fadeIn 0.6s ease-in-out;
    }
`

export const DashboardBody = styled.div`
    display: grid;
    grid-gap: var(--dashboard-default-gap);
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    padding: 0;
    & > div {
        transition: box-shadow 0.3s ease-in-out;
    }
`
export const UpdatedInfo = styled.div`
    grid-area: 1/7/1/9;
    font-size: 13px;
    font-style: italic;
    color: var(--dashboard-secondary-color);
    display: flex;
    align-items: center;
    justify-content: flex-end;
`
